import { floor } from 'lodash';
import * as moment from 'moment';

import { InspectionRecurrencePeriod } from '@main-application/inspections/models/rest-inspections-model.interface';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';

export const GetRecurrencePeriodTypeList = (dueDate: Date): IRadioButtonOption<InspectionRecurrencePeriod>[] => {
  if (!dueDate) {
    return [];
  }
  const dayOfWeek = moment(dueDate).format('dddd');
  const weekNumber = floor(dueDate.getDate() / 7) + 1;
  let weekNumberText = 'N/A';

  switch (weekNumber) {
    case 1:
      weekNumberText = 'first';
      break;
    case 2:
      weekNumberText = 'second';
      break;
    case 3:
      weekNumberText = 'third';
      break;
    case 4:
      weekNumberText = 'fourth';
      break;
    case 5:
      weekNumberText = 'fifth';
      break;
    default:
      weekNumberText = 'N/A';
  }

  const today = moment(dueDate).format('MMMM D');
  const semi1 = moment(dueDate).format('MMM D');
  const semi2 = moment(dueDate).add(7, 'month').format('MMM D');
  return [
    {
      value: InspectionRecurrencePeriod.DoNotRepeat,
      label: 'Does not repeat',
    },
    {
      value: InspectionRecurrencePeriod.Daily,
      label: 'Weekdays',
    },
    {
      value: InspectionRecurrencePeriod.Weekly,
      label: `Weekly on ${dayOfWeek}`,
    },
    {
      value: InspectionRecurrencePeriod.MonWedFri,
      label: `Weekly on Monday, Wednesday, Friday`,
    },
    {
      value: InspectionRecurrencePeriod.MonFri,
      label: `Weekly on Monday, Friday`,
    },
    {
      value: InspectionRecurrencePeriod.TueTh,
      label: `Weekly on Tuesday, Thursday`,
    },
    {
      value: InspectionRecurrencePeriod.SemiMonthly,
      label: `Semi-monthly every other ${dayOfWeek}`,
    },
    {
      value: InspectionRecurrencePeriod.Monthly,
      label: `Monthly on the first ${dayOfWeek}`,
    },
    weekNumber == 1
      ? null
      : {
          value: InspectionRecurrencePeriod.SameWeekMonthly,
          label: `Monthly on the ${weekNumberText} ${dayOfWeek}`,
        },
    {
      value: InspectionRecurrencePeriod.SemiAnnually,
      label: `Semi-annually on ${semi1} and ${semi2}`,
    },
    {
      value: InspectionRecurrencePeriod.Quarterly,
      label: `Quarterly on the first ${dayOfWeek}`,
    },
    weekNumber == 1
      ? null
      : {
          value: InspectionRecurrencePeriod.SameWeekQuarterly,
          label: `Quarterly on the ${weekNumberText} ${dayOfWeek}`,
        },
    {
      value: InspectionRecurrencePeriod.Annually,
      label: `Annually on ${today}`,
    },
    {
      value: InspectionRecurrencePeriod.EveryTwoYears,
      label: `Every 2 Years on ${today}`,
    },
    {
      value: InspectionRecurrencePeriod.EveryThreeYears,
      label: `Every 3 Years on ${today}`,
    },
    {
      value: InspectionRecurrencePeriod.EveryFourYears,
      label: `Every 4 Years on ${today}`,
    },
    {
      value: InspectionRecurrencePeriod.EveryFiveYears,
      label: `Every 5 Years on ${today}`,
    },
    {
      value: InspectionRecurrencePeriod.EveryTenYears,
      label: `Every 10 Years on ${today}`,
    },
  ].filter(x => x != null);
};
